<template>
  <div>
    <v-navigation-drawer
      :value="isOpen"
      absolute
      right
      width="600px"
      style="z-index: 6; position: fixed"
      :height="dialogHeight"
      touchless
      hide-overlay
      stateless
    >
      <v-card elevation="0" class="ma-7" style="background-color: transparent;">
        <v-card-title class="text-h5">{{getTranslated('_editLabel')}}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" v-model="valid" ref="form" style="flex: 1 1 auto">
            <v-text-field v-if="clone" v-model="label.name" outlined :label="getTranslated('_name')"></v-text-field>
            <v-textarea v-model="label.description" outlined auto-grow maxlength="255" counter="255" :label="getTranslated('_description')"></v-textarea>
            <v-card class="mt-6 py-5">
              <v-row v-for="(item, index) in label.purposes" :key="index" align="center">
                <div style="width: 220px"><v-select class="mx-6" :items="purposesList" v-model="item.type.id" item-text="purposeTypeName" item-value="id" :label="getTranslated('_name')" :no-data-text="getTranslated('_selectNoData')"></v-select></div>
                <div style="width: 250px"><v-text-field class="mx-6" :label="getTranslated('_value')" v-model="item.purposeValue"></v-text-field></div>
                <v-btn class="mr-6" icon color="primary" @click="deleteNameValue(item)"><v-icon>delete</v-icon></v-btn>
              </v-row>
              <v-row align="center">
                <div style="width: 220px"><v-select class="mx-6" :items="purposesList" v-model="newName" item-text="purposeTypeName" item-value="id" :label="getTranslated('_name')" :no-data-text="getTranslated('_selectNoData')"></v-select></div>
                <div style="width: 250px"><v-text-field class="mx-6" :label="getTranslated('_value')" v-model="newValue"></v-text-field></div>
                <v-tooltip top :disabled="newName !== ''" transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn class="mr-6" icon color="primary" @click="addNewNameValue()" :disabled="!newName"><v-icon>add_circle_outline</v-icon></v-btn>
                    </div>
                  </template>
                  <span>{{getTranslated('_addRequiredValuesAlert')}}</span>
                </v-tooltip>
              </v-row>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text :disabled="!valid" :loading="loading" @click.stop="save">{{getTranslated('_save')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click.stop="cancel">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <v-overlay :value="isOpen" z-index="5">
    </v-overlay>
  </div>
</template>

<script>
import LabelDesignerService from '../services/LabelDesignerService.js'
import { mapActions, mapState } from 'vuex'
import { actions } from '../store/types/labelTypes.js'

export default {
  name: 'LabelEditionDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    clone: {
      type: Boolean,
      defualt: false
    },
    translations: Array
  },
  data () {
    return {
      title: '',
      valid: false,
      purposesList: [],
      newName: '',
      newValue: '',
      requiredRule: [v => !!v || this.getTranslated('_required')],
      dialogHeight: window.innerHeight,
      loading: false
    }
  },
  computed: {
    ...mapState({
      label: state => state.labels.label
    }),
    isOpen: {
      get () {
        return this.openDialog
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapActions({
      saveLabel: actions.SAVE_LABEL,
      cloneLabel: actions.CLONE_LABEL,
      clearLabel: actions.CLEAR_LABEL
    }),
    async getPurposes () {
      await LabelDesignerService.getPurposes().then(res => {
        this.purposesList = res.data
      })
    },
    async save () {
      this.loading = true
      if (this.newName && this.newValue) {
        this.addNewNameValue()
      }
      if (this.clone) {
        await this.cloneLabel(this.label).then(res => {
          var notification = {
            color:
              res.request.status === 200 || res.request.status === 201
                ? 'green'
                : 'red',
            message:
              res.request.status === 200 || res.request.status === 201
                ? this.getTranslated('_labelSaved')
                : this.getTranslated('_labelSavedError')
          }
          this.loading = false
          this.$emit('saved', notification)
          this.cancel()
        })
      } else {
        await this.saveLabel(this.label).then(res => {
          var notification = {
            color:
              res.request.status === 200 || res.request.status === 201
                ? 'green'
                : 'red',
            message:
              res.request.status === 200 || res.request.status === 201
                ? this.getTranslated('_labelSaved')
                : this.getTranslated('_labelSavedError')
          }
          this.loading = false
          this.$emit('saved', notification)
          this.cancel()
        })
      }
    },
    deleteNameValue (item) {
      var indexOfItem = this.label.purposes.indexOf(item)
      this.label.purposes.splice(indexOfItem, 1)
    },
    addNewNameValue () {
      var newName = this.newName
      var newValue = this.newValue
      var nameValue = {
        type: {
          id: newName
        },
        purposeValue: newValue,
        labelId: this.label.id,
        labelVersion: this.label.version
      }
      this.label.purposes.push(nameValue)
      this.newName = ''
      this.newValue = ''
    },
    async initialize () {
      await this.getPurposes()
    },
    cancel () {
      this.loading = false
      this.isOpen = false
      this.$refs.form.reset()
      this.clearLabel()
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    handleResize (event) {
      this.dialogHeight = window.innerHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.initialize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
